import React, { createContext, useState } from "react";

const CampaignModuleContext = createContext();

/**
 * @param {React.ReactChild} chidren Children components inside the context
 * @returns {React.Provider} Campaign Module context for redirection from other modules
 */
const CampaignModuleProvider = ({ children }) => {
  const [campaignId, setCampaignId] = useState(0);
  const [accountId, setAccountId] = useState(0);
  const [brandId, setBrandId] = useState(0);
  const [isCreationRedirect, setIsCreationRedirect] = useState(0);
  const [campaignViewAccountId, setCampaignViewAccountId] = useState(0);
  const [campaignViewBrandId, setCampaignViewBrandId] = useState(0);
  const [campaignViewCreativeId, setCampaignViewCreativeId] = useState(0);
  const [showNoCampaignScreen, setShowNoCampaignScreen] = useState(false);
  const [campaignViewRefresh, setCampaignViewRefresh] = useState(false);
  const [campaignBlockingView, setCampaignBlockingView] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [pageName, setPageName] = useState("Campaign");
  const [isRedirected, setIsRedirected] = useState(false);
  const [campaignStatus, setCampaignStatus] = useState({
    campaignComplete: false,
    targetingComplete: false,
    pricingComplete: false,
    creativeComplete: false,
    summaryComplete: false,
  });

  const [selectFromCampaignDetails, setSelectFromCampaignDetails] = useState();
  const [audienceClickers, setAudienceClickers] = useState({});
  const [activeCampaignStrategyId, setActiveCampaignStrategyId] = useState();
  const [audiencetargetingflag, setAudiencetargetingflag] = useState(false);
  const [segmentSubSegmentData, setSegmentSubSegmentData] = useState([]);
  const [activeCampaignBrandId, setActiveCampaignBrandId] = useState();
  const handleStepClick = (step) => {
    setActiveStep(step);
    window.scrollTo(0, 0); // Scroll to top of the page after clicking on a step
    if (step === 0) {
      setPageName("Campaign");
    } else if (step === 1) {
      setPageName("Targeting");
    } else if (step === 2) {
      setPageName("Pricing");
    } else if (step === 3) {
      setPageName("Creative");
    } else if (step === 4) {
      setPageName("Summary");
    }
  };

  return (
    <CampaignModuleContext.Provider
      value={{
        campaignId,
        setCampaignId,
        campaignViewAccountId,
        setCampaignViewAccountId,
        campaignViewBrandId,
        setCampaignViewBrandId,
        campaignViewCreativeId,
        setCampaignViewCreativeId,
        campaignViewRefresh,
        setCampaignViewRefresh,
        campaignBlockingView,
        setCampaignBlockingView,
        activeStep,
        setActiveStep,
        pageName,
        setPageName,
        handleStepClick,
        campaignStatus,
        setCampaignStatus,
        isCreationRedirect,
        setIsCreationRedirect,
        accountId,
        setAccountId,
        brandId,
        setBrandId,
        isRedirected,
        setIsRedirected,
        selectFromCampaignDetails,
        setSelectFromCampaignDetails,
        showNoCampaignScreen,
        setShowNoCampaignScreen,
        audienceClickers,
        setAudienceClickers,
        activeCampaignStrategyId,
        setActiveCampaignStrategyId,
        audiencetargetingflag,
        setAudiencetargetingflag,
        segmentSubSegmentData,
        setSegmentSubSegmentData,
        activeCampaignBrandId,
        setActiveCampaignBrandId
      }}
    >
      {children}
    </CampaignModuleContext.Provider>
  );
};

export { CampaignModuleProvider, CampaignModuleContext };
